//# sourceMappingURL=context.mjs.map
/// <reference types="./context.d.mts" />
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import { Ok, CustomType as $CustomType, makeError } from "../../gleam.mjs";
import { getContext as get, createContext as create } from "./context.ffi.mjs";

export { create, get };

const FILEPATH = "src/redraw/unsafe/context.gleam";

/**
 * Error returned from `create_`.
 * Context with the corresponding `name` already exists.
 */
export class ExistingContext extends $CustomType {
  constructor(name) {
    super();
    this.name = name;
  }
}
export const Error$ExistingContext = (name) => new ExistingContext(name);
export const Error$isExistingContext = (value) =>
  value instanceof ExistingContext;
export const Error$ExistingContext$name = (value) => value.name;
export const Error$ExistingContext$0 = (value) => value.name;

/**
 * Error returned from `get`.
 * Context with the corresponding `name` does not exists.
 */
export class UnknownContext extends $CustomType {
  constructor(name) {
    super();
    this.name = name;
  }
}
export const Error$UnknownContext = (name) => new UnknownContext(name);
export const Error$isUnknownContext = (value) =>
  value instanceof UnknownContext;
export const Error$UnknownContext$name = (value) => value.name;
export const Error$UnknownContext$0 = (value) => value.name;

export const Error$name = (value) => value.name;

/**
 * `context` emulates classic Context usage in React. Instead of calling
 * `create` and `get`, it's possible to simply call `context`,
 * which will get or create the context directly, and allows to write code as
 * if Context is globally available. `context` also tries to preserve
 * type-checking at most. `context.default_value` is lazily evaluated, meaning
 * no additional computations will ever be run.
 *
 * ```gleam
 * import redraw
 * import redraw/unsafe/context
 *
 * const context_name = "MyContextName"
 *
 * pub type MyContext {
 *   MyContext(count: Int, set_count: fn (Int) -> Nil)
 * }
 *
 * fn default_value() {
 *   let count = 0
 *   les set_count = fn (_) { Nil }
 *   MyContext(count:)
 * }
 *
 * pub fn provider() {
 *   use _, children <- redraw.component_()
 *   let context = context.context(context_name, default_value)
 *   let #(count, set_count) = redraw.use_state(0)
 *   redraw.provider(context, MyContext(count:, set_count:), children)
 * }
 *
 * pub fn use_my_context() {
 *   let context = context.context(context_name, default_value)
 *   redraw.use_context(context)
 * }
 * ```
 *
 * `context` should never fail, but it can be wrong if you use an already used
 * name.
 */
export function context(name, default_value) {
  let $ = get(name);
  if ($ instanceof Ok) {
    let context$1 = $[0];
    return context$1;
  } else {
    let get$1 = $[0];
    let $1 = create(name, default_value());
    if ($1 instanceof Ok) {
      let context$1 = $1[0];
      return context$1;
    } else {
      let create$1 = $1[0];
      let _block;
      let _pipe = "[Redraw Internal Error] Unable to find or create context.\n";
      let _pipe$1 = $string.append(
        _pipe,
        "context should never panic. Please, open an ",
      );
      let _pipe$2 = $string.append(
        _pipe$1,
        "issue on https://github.com/ghivert/redraw, ",
      );
      let _pipe$3 = $string.append(_pipe$2, "and join the error details.\n");
      let _pipe$4 = $string.append(_pipe$3, "Error details:\n");
      let _pipe$5 = $string.append(
        _pipe$4,
        ("  get: " + $string.inspect(get$1)) + "\n",
      );
      _block = $string.append(_pipe$5, "  create: " + $string.inspect(create$1));
      throw makeError(
        "panic",
        FILEPATH,
        "redraw/unsafe/context",
        112,
        "context",
        _block,
        {}
      )
    }
  }
}
